/**
 * TanStack Query Client Configuration
 * Requirements: 4.2, 4.5
 * 
 * Provides QueryClient with default options for data fetching,
 * caching, and mutation handling.
 */

import { QueryClient } from '@tanstack/react-query';

/**
 * Default stale time for queries (5 minutes)
 */
const DEFAULT_STALE_TIME = 5 * 60 * 1000;

/**
 * Default retry count for failed queries
 */
const DEFAULT_RETRY_COUNT = 3;

/**
 * Create and configure the QueryClient
 * Requirements: 4.2
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is considered fresh for 5 minutes
      staleTime: DEFAULT_STALE_TIME,
      // Retry failed queries up to 3 times
      retry: DEFAULT_RETRY_COUNT,
      // Don't refetch on window focus by default for authoring app
      refetchOnWindowFocus: false,
      // Keep previous data while fetching new data
      placeholderData: (previousData: unknown) => previousData,
    },
    mutations: {
      // Retry failed mutations up to 3 times
      retry: DEFAULT_RETRY_COUNT,
      // Exponential backoff for retries
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
});
